import axios, {AxiosInstance} from 'axios';
import {PinxToken, User} from '@/models';
import store from '../store';

const AXIOS = axios.create({
  // headers Bearer 토큰은 App.vue 에서 모니터링해서 설정됨.
  baseURL: '/api',
  timeout: 600000,
});
setInterceptors(AXIOS);
let isTokenRefreshing = false;
let refreshSubscribers: any[] = [];

const onTokenRefreshed = (accessToken: any) => {
  refreshSubscribers.map(callback => callback(accessToken));
  refreshSubscribers = [];
};

const addRefreshSubscriber = (callback: any) => {
  refreshSubscribers.push(callback);
};

function setInterceptors(instance: AxiosInstance) {
  instance.interceptors.request.use(
    function (config) {
      // Do something before request is sent
      config.headers.common['X-Requested-With'] = 'XMLHttpRequest';
      config.headers.common['pinxToken'] = store.getters['Auth/pinxToken'];
      return config;
    },
    function (error) {
      // Do something with request error
      return Promise.reject(error);
    },
  );
  instance.interceptors.response.use(
    response => {
      return response;
    },
    async error => {
      console.error(error);
      const {
        config,
        response: {status},
      } = error;

      const originalRequest = config;
      if (status === 401) {
        const userLogined = store.getters['Auth/isLoggedIn'];
        const guestLogined = store.getters['Auth/isGuestLoggedIn'];

        if (!guestLogined && !userLogined) {
          window.location.href = '/p/login';
          return error;
        }
        if (!isTokenRefreshing) {
          // isTokenRefreshing이 false인 경우에만 token refresh 요청
          isTokenRefreshing = true;
          //TODO : 아래 과정을 store/Auth 내부로 모두 옮겨야 함.
          const tokenObj = await store.dispatch('Auth/refreshToken');

          if (tokenObj != null) {
            originalRequest.headers['pinxToken'] = tokenObj.pinxToken;
            //console.log(originalRequest);
            // 새로운 토큰으로 지연되었던 요청 진행
            isTokenRefreshing = false;
            onTokenRefreshed(tokenObj.pinxToken);
            // 최초로 401에러 받은 요청 처리.
            return instance(originalRequest);
          } else {
            // 토큰 갱신이 안된경우 로그아웃 시킨다.
            window.location.href = '/p/login';
            isTokenRefreshing = false;
            return error;
          }
        }
        // token이 재발급 되는 동안의 요청은 refreshSubscribers에 저장
        return new Promise(resolve => {
          addRefreshSubscriber((accessToken: any) => {
            originalRequest.headers['pinxToken'] = accessToken;
            resolve(instance(originalRequest));
          });
        });
      }
      return Promise.reject(error);
    },
  );
  return instance;
}

export default AXIOS;
